import { useEffect } from "react";

import {
  playerAddress,
  type PlayerState,
} from "@/lib/timeline/view/UrlOptions/address";

/** The book's own address, whichever chapter is on screen. */
export function currentBookPath(): string {
  return window.location.pathname.split("/").slice(0, 3).join("/");
}

/** Keeps the address bar on what is showing. It is read only on arrival, so nothing reloads. */
export function usePlayerAddressBar(state: PlayerState): void {
  const { journey, spanId, cameraLock, autoZoom } = state;
  useEffect(() => {
    window.history.replaceState(
      window.history.state,
      "",
      playerAddress(currentBookPath(), { journey, spanId, cameraLock, autoZoom }),
    );
  }, [journey, spanId, cameraLock, autoZoom]);
}
